import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { Button, CircularProgress, Tooltip } from '@mui/material'
import type { FC } from 'react'
import { useSnackbar } from 'src/components/snackbar/useSnackbar'
import type { BBox } from './cropBBoxToCanvas'
import type { ReadResult } from './useAutoReader'

type Props = {
  imageUrl: string
  bbox: BBox
  disabled: boolean
  isLoading: boolean
  successMessage: string
  onRead: (value: string) => void
  readFn: (imageUrl: string, bbox: BBox) => Promise<ReadResult>
}

export const AutoReadButton: FC<Props> = ({
  imageUrl,
  bbox,
  disabled,
  isLoading,
  successMessage,
  onRead,
  readFn,
}) => {
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar()

  const handleClick = async () => {
    if (isLoading) return
    const result = await readFn(imageUrl, bbox)

    if (result.success) {
      onRead(result.value)
      showSuccessSnackbar(successMessage)
    } else {
      showErrorSnackbar(result.error)
    }
  }

  const isDisabled = disabled || isLoading

  return (
    <Tooltip title="目視でもご確認ください。読み取れた場合は高精度で検査ができます。">
      <span>
        <Button
          variant="outlined"
          onClick={handleClick}
          disabled={isDisabled}
          startIcon={
            isLoading ? <CircularProgress size={20} /> : <AutoFixHighIcon />
          }
          sx={{
            whiteSpace: 'nowrap',
            minWidth: 'auto',
            height: '56px', // MUI TextField のデフォルト高さに合わせる
            '& .MuiButton-startIcon': {
              display: 'flex',
              alignItems: 'center',
            },
          }}
        >
          読み取る
        </Button>
      </span>
    </Tooltip>
  )
}
